export default __webpack_public_path__ + "locales/pl/EmbeddingPanel.json?hash=ed709a6b192e9b340a9430bdb06e2aef";